import DatePicker, { registerLocale } from 'react-datepicker';
import { ru } from 'date-fns/locale/ru';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('ru', ru);

type Props = {
  value: Date | null;
  onChange: (value: Date | null) => void;
  width?: number | string;
  placeholder?: string;
};

/** react-datepicker with time, styled like legacy AdminLTE `date-control`. */
export const FilterDateTime = ({
  value,
  onChange,
  width = '100%',
  placeholder = 'Выбор даты',
}: Props) => (
  <div className="filter-datepicker" style={{ width }}>
    <DatePicker
      selected={value}
      onChange={onChange}
      showTimeSelect
      timeFormat="HH:mm"
      timeIntervals={5}
      timeCaption="Время"
      dateFormat="d.MM.yyyy HH:mm"
      placeholderText={placeholder}
      locale="ru"
      isClearable
      className="date-control"
      injectTimes={[
        new Date(new Date().setHours(0, 1, 0, 0)),
        new Date(new Date().setHours(12, 5, 0, 0)),
        new Date(new Date().setHours(23, 59, 0, 0)),
      ]}
    />
  </div>
);
